"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSelectedLoadCaseFlow = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.setSelectedLoadCaseFlow = (0, graphql_tag_1.default) `
  mutation SetSelectedLoadCaseFlow(
    $moistureLoadId: ID!
    $caseId: ID!
    $flowId: ID!
  ) {
    setSelectedLoadCaseFlow(
      moistureloadId: $moistureLoadId
      caseId: $caseId
      flowId: $flowId
    ) {
      id
    }
  }
`;
//# sourceMappingURL=set-selected-load-case-flow.js.map